import { msg } from '@gonfalon/messages/msg';
import { useProjectId } from '@gonfalon/observability-ui/hooks/useProjectId';
import { Icon } from '@launchpad-ui/icons';
import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';

import { getMentionResourceUrl, getResourceTypeIconName } from './mentionUtils';

import { inlineToken, inlineTokenLabel, inlineTokenLinkIcon } from '../../../components/mentions/mentions.css';

export function MentionToken({ node }: NodeViewProps) {
  const { id, label, resourceType } = node.attrs as { id: string; label: string; resourceType: string };
  const { projectKey } = useProjectId();
  const url = getMentionResourceUrl(projectKey, resourceType, id);

  return (
    <NodeViewWrapper as="span">
      <span className={inlineToken} contentEditable={false}>
        <Icon name={getResourceTypeIconName(resourceType)} size="tiny" />
        <span className={inlineTokenLabel}>{label}</span>
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={inlineTokenLinkIcon}
            onClick={(e) => e.stopPropagation()}
            aria-label={msg('vega.mentions.openResourceLabel', { resourceType: resourceType.toLowerCase() })}
          >
            <Icon name="link-external" size="tiny" />
          </a>
        )}
      </span>
    </NodeViewWrapper>
  );
}
